import { ListingService } from '~/modules/services/listing_service';
export * from '~/modules/services/listing_service';

export const listingService = new ListingService();
